export const CONFERENCE_INFO = {
    alwaysVisible: [ 'recording', 'local-recording' ],
    autoHide: [
        'subject',
        'conference-timer',
        'participants-count',
        'e2ee',
        'transcribing',
        'video-quality',
        'insecure-room'
    ]
};
